module.exports = __webpack_public_path__ + "static/media/case1.21e85a6e.png";